import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { toastMessageInterface } from '../../../common/interface/common.interface';
import { TOAST_OPTIONS } from '../../../common/constants/common.constants';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-toast-alerts',
  imports: [CommonModule],
  templateUrl: './toast-alerts.component.html',
  styleUrl: './toast-alerts.component.css'
})
export class ToastAlertsComponent implements OnInit {
  type: "SUCCESS" | "ERROR" | "WARNING" | "INFO" | "CLEAR" | undefined;
  toast: any;
  message: string | undefined;
  timer: any | undefined;
  timeout: any | undefined;
  timebreak: number = 0;
  showProgressBar: boolean = false;
  
  constructor(
    private toastr: ToastService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.toastr.alert$
      .subscribe((result: toastMessageInterface) => {
        this.showToast(result);
      });
  }

  showToast(result: toastMessageInterface): void {
    if (result.type) {
      this.type = result.type;
      if (this.type.includes("CLEAR"))
        this.clearToast();
      else {
        this.toast = TOAST_OPTIONS[this.type];
        this.message = result.message;
        let closetime = 3000;
        this.timeout = setTimeout(() => {
          this.clearToast();
        }, closetime);
        if (result.progressBar) {
          this.showProgressBar = true;
          let startTime: number = Date.now();
          this.timer = setInterval(() => {
            let now: number = Date.now();
            let elapsed: number = now - startTime;
            const progress = Math.min(elapsed / closetime, 1);
            this.timebreak = Math.floor(progress * 100);
  
            if (progress === 1) {
              this.timebreak = 0;
              this.showProgressBar = false;
              clearInterval(this.timer);
            }
          }, 100);  
        }
      }
    }
  }

  clearToast(): void {
    this.type = undefined;
    this.message = undefined;
    this.toast = undefined;
    if (this.timer) {
      this.timebreak = 0;
      this.showProgressBar = false;
      clearInterval(this.timer);
    }
    if (this.timeout)
      clearTimeout(this.timeout);
  }

  parseHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
